import React, { useState } from "react"

import "./styles.css"

import Ability from "../../components/Ability";
import {FaPuzzlePiece} from "react-icons/fa";
import Layout from "../../components/Layout";

const Filter = () => {
  const [selected, setSelected] = useState([0, 0, 0])
  const types = ["Comunicativa", "Social", "Motora"]

  const params = new URLSearchParams()
  types.forEach((type, index) => {
    const value = selected[index]
    if (value !== 0) {
      params.append(`${type.toLowerCase()}`, value)
    }
  })
  const queryString = params.toString()
  const resultUrl = queryString
    ? `/filter/result?${queryString}`
    : "/filter/result"

  function renderHabilities() {
    return types.map((item, index) => (
      <div key={index}>
        <Ability
          type={item}
          types={types}
          selected={selected}
          setSelected={setSelected}
        />
      </div>
    ))
  }

  return (
    <Layout
      title="Filtro"
      titleColor="#1dab7d"
      description='Indique abaixo qual o nível de habilidade percebido no
      paciente. Clique em "Atividades Sugeridas" para obter as sugestões do 
      sistema.'
      children={<div className="filter-container">{renderHabilities()}</div>}
      button={{
        text: "Atividades Sugeridas",
        icon: <FaPuzzlePiece />,
        router: resultUrl,
        clickHandle: (event) => {
          if (selected.every(it => it === 0)) {
            event.preventDefault()
            alert(
              "É necessário fornecer ao menos 1 nível de habilidade para prosseguir.",
            )
          } else {
            console.log("Habilidades selecionadas: ", selected)
          }
        },
      }}
    />
  )
}

export default Filter
